import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import store from '../../store';
import { showModal, MODAL_PIN } from '../../actions/modal';
import {
    updateValuesStorageToContinue,
    modalInactivityPlayOnLIVE,
    handleRedirectModalInactivity,
} from 'src/components/Modal/functions/ModalInactivity/index';
import { AAF_CONTENT_IS_CATCHUP, AAF_CONTENT_IS_STARTOVER, AAF_CONTENT_IS_TV } from 'src/AAFPlayer/constants';
import { CONTENT_KEYS } from './constants/ModalInactivity';
import 'src/components/Modal/styles/ModalInactivity.scss';
import Utils from 'src/utils/Utils';
import PlayerControlsLogic from 'src/playerDomain/components/PlayerControlsLogic.js';
import {AAFPLAYER_PLAY, AAFPLAYER_STOP} from './../../AAFPlayer/constants'
import { playFullMedia } from '../../actions/playmedia';
import TvChannelUtil from '../../utils/TvChannelUtil';

class ModalInactivity extends Component {
    constructor(props) {
        super(props);
        this.extraClass = 'btn-modal-bookmark';
        this.variant = 'dark';
        const {
            contentStreamType,
            contentTypes
        } = store.getState().modalInactivity;
        this.contentStreamType = contentStreamType;
        this.contentType = PlayerControlsLogic.getContentType(this.contentStreamType);
        this.contentTypes = contentTypes;
        this.exitButton =
            this.contentTypes[this.contentType].exitButton ?
            this.contentTypes[this.contentType].exitButton.action : '';
        this.params = {
            classNameComponent: 'modal-inactivity',
            showLogo: false,
            aafNewStyle: true,
            alwaysEnabled: true,
            buttonsAlign: 'vertical',
            className: 'aaf-modal aaf-modal-error',
            content: this.getContentText("title"),
            buttons: this.getButtonsModalInactivity(),
            backRCU: () => this.handleOnClickReturn(this.exitButton),
        };
        this.setTimeOutModal = null;
        this.idFocusOnShortcut = null;
    }

    getButtonsModalInactivity = () => {
        const continueButton = {
            content: this.getContentText("continue"),
            extraClass: `${this.extraClass} modal-inactivity__button-continue`,
            props: {
                variant: this.variant,
                onClick: this.handleOnClickContinue,
            },
        };
        const backButton = {
            content: this.getContentText("exit"),
            extraClass: `${this.extraClass} modal-inactivity__button-back`,
            props: {
                variant: this.variant,
                onClick: () => this.handleOnClickReturn(this.exitButton),
            },
        };
        const goLiveButton = {
            content: this.getContentText("live"),
            extraClass: `${this.extraClass} modal-inactivity__button-golive`,
            props: {
                variant: this.variant,
                onClick: this.handleOnClickGoLive,
            },
        };
        if(this.contentStreamType === AAF_CONTENT_IS_CATCHUP || this.contentStreamType === AAF_CONTENT_IS_STARTOVER){
            return [continueButton, goLiveButton, backButton]
        } else{
            return [continueButton, backButton]
        }
    }

    getContentText = (type = null) => {
        if (type && this.contentStreamType) {
            if (CONTENT_KEYS[type] && CONTENT_KEYS[type][this.contentStreamType]) {
                const key = CONTENT_KEYS[type][this.contentStreamType];
                return Translator.get(key, '');
            }
        }
        return "";
    }

    checkTimesInStartOver = () => {
        const { timeEndStartOver } = store.getState().modalInactivity;
        const endContent = `${new Date(timeEndStartOver).toLocaleDateString()} ${new Date(
            timeEndStartOver
        ).toLocaleTimeString()}`;
        const nowDate = `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
        return nowDate < endContent ? true : false;
    };

    addFocusNotification = () => {
        if (!Utils.isNotificationHide()) {
            this.idFocusOnShortcut = setTimeout(() => {
                window.SpatialNavigation.focus('#notification-shortcut-button');
                this.idFocusOnShortcut = null;
            }, 300);
        }
    };

    closeModal = () => {
        store.dispatch(
            showModal({
                modalType: 'HIDE_MODAL',
                modalProps: {},
            })
        );
    };

    handleOnClickReturn = (urlRedirect = '') => {
        handleRedirectModalInactivity(this.props.exit, this.props.history, urlRedirect);
        this.props.resetDataModalSleep();
        this.closeModal();
        Utils.setInitialFocusChangeTime(localStorage.getItem("lastFocusRecord"), 1000);
    };

    handleOnClickContinue = () => {
        const { contentStreamType } = store.getState().modalInactivity;
        if (contentStreamType === AAF_CONTENT_IS_STARTOVER) {
            const validated = this.checkTimesInStartOver();
            updateValuesStorageToContinue();
            validated ? this.props.play() : modalInactivityPlayOnLIVE();
            this.addFocusNotification();
            this.closeModal();
        } else if(contentStreamType === AAF_CONTENT_IS_TV){
            this.closeModal();
            const paramsStop = {
                            playerstate: AAFPLAYER_STOP,
                            source: null,
            }
            store.dispatch(playFullMedia(paramsStop));
            let lastChannel = TvChannelUtil.getLastChannel();
            const paramsPlay = {
                    playerstate: AAFPLAYER_PLAY,
                    source: {
                        videoid: lastChannel
                    },
                    islive: true,
                    ispip: false,
            };
            setTimeout(() => {
                 store.dispatch(playFullMedia(paramsPlay));
            }, 500);
        } else {
            updateValuesStorageToContinue();
            this.closeModal();
            this.props.play && this.props.play();
            this.addFocusNotification();
        }
    };

    handleOnClickGoLive = () => {
        this.closeModal();
        this.props.goToLive()
    };

    componentDidMount = () => {
        const { fullEPG } = store.getState().modalInactivity;
        const modalActiveTime = this.contentTypes[this.contentType].alert.displayDurationMinutes * 60000;
        const redirectPath =
            this.contentTypes[this.contentType].alert.redirectPath ?
            this.contentTypes[this.contentType].alert.redirectPath : '';
        this.setTimeOutModal = setTimeout(() => {
            this.handleOnClickReturn(redirectPath);
        }, modalActiveTime);
        this.props && typeof this.props.clearLoading === 'function' &&   this.props.clearLoading(); // se ejecuta solo cuando se abre el modal despues de modal PIN
        fullEPG && this.props.toggleEPG(); // solo para live
    };
    componentWillUnmount = () => {
        clearTimeout(this.setTimeOutModal);
    };

    render() {
        return <ModalWrapper {...this.params} />;
    }
}

export default withOnClose(ModalInactivity);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalInactivity.jsx